<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'
    
   export default {
      page: {
         title: "Bookings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {

         const today_str = moment().format("YYYY-MM-DDThh:mm");
         const today = moment().format("YYYY-MM-DD HH:mm:ss");
         return {
            title: "Bookings",
            items: [
               {
                  text: "Bookings",
                  active: true,
               },                   
            ],

            listing_length: 10,
            keyword: '',
            status: '',
            from: null,
            to: null,
            total: null,
            pagination: {},
            token: '',
            errors: {},
            loading: false,

            bookings: [],

            booking: {
               id: "",
               booking_time: "",
            },
            min_date: today_str,
            now: today,

            active_page_url: "",
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchBookings();
      },

      methods: {

         fetchBookings(page_url = null) {

            this.getToken();
            let url = "admin/bookings/index?limit=" + this.listing_length + "&status=" + this.status + "&keyword=" + this.keyword;
            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;

            this.loading = true;
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  this.bookings = responseData.bookings.data;
                  console.log(responseData);
                  this.pagination = responseData.bookings.links;
                  this.from = responseData.bookings.from;
                  this.to = responseData.bookings.to;
                  this.total = responseData.bookings.total;
               })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('sigomind_admin')) {
               var sigomind_admin =  JSON.parse(localStorage.getItem('sigomind_admin'));
               if(sigomind_admin.token) {
                  this.token = sigomind_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         completeBooking(booking_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to complete this booking?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };

                  let url = "admin/bookings/complete?booking_id=" + booking_id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchBookings(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },

         reschedule(booking) {
            this.booking.id = booking.id;
            this.booking.booking_time = "";
            this.showModal('reschedule-modal');
         },

         clearForm() {
            this.booking.id = "";
            this.booking.booking_time = "";
            this.errors = {};
         },

         updateBooking() {
            this.getToken();            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let formData = new FormData();
            formData.append("booking_id", this.booking.id);            

            let datetime = moment.utc(this.booking.booking_time).format("YYYY-MM-DD HH:mm:ss");
            formData.append("booking_time", datetime);         
        
            let url = 'admin/bookings/reschedule';
                   
            this.loading = true;


            this.$axios
               .post(url, formData, config)
               .then((response) => {
                     if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                     } else {
                        this.$swal("", response.data.message, "error");
                     }

                     this.hideModal("reschedule-modal");
                     this.fetchBookings(this.active_page_url);
               })
               .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
               })
               .finally(() => (this.loading = false));
         },

         cancelBooking(booking_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to cancel this booking?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };

                  let url = "admin/bookings/cancel?booking_id=" + booking_id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchBookings(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'bookings.add' }" class="btn btn-primary float-end">Add Booking</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchBookings()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchBookings()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchBookings()">
                                 <option value="">All</option>
                                 <option value="2">Confirmed</option>
                                 <option value="3">Completed</option>
                                 <option value="5">Rescheduled</option>
                                 <option value="4">Cancelled</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>ID</th>
                              <th>User</th>
                              <th>Patient</th>  
                              <th>Doctor</th>                            
                              <th>Date & Time</th>
                              <th>Clinic</th>   
                              <th>Status</th>
                              <td>Created On</td>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(bookings.length)">
                           <tr v-for="(booking) in bookings" :key="booking.id">
                              <td>{{booking.id}}</td>
                              <td>
                                 <div v-if="booking.patient">
                                    <p class="mb-0">{{booking.patient.name}}</p>
                                    <p class="mb-0 w-120px">{{booking.patient.converted_mobile}}</p>
                                 </div>
                                 <div v-else>
                                    <p class="text-danger">Deleted</p>
                                 </div>
                              </td>
                              <td>
                                 <div v-if="booking.patient">
                                    <div v-if="booking.booking_for==2">
                                       <p class="mb-0">{{booking.others_name}}</p>
                                       <p class="mb-0 w-120px">{{booking.converted_others_mobile}}</p>
                                    </div>
                                    <div v-else>
                                       <p class="mb-0">{{booking.patient.name}}</p>
                                       <p class="mb-0 w-120px">{{booking.patient.converted_mobile}}</p>
                                    </div>
                                 </div>
                              </td>
                              <td>{{booking.doctor.doctor_name}} <br>{{booking.doctor.qualification}}</td>
                              <td><p class="w-100px">{{booking.converted_booking_datetime}}</p></td>
                              <td>{{booking.clinic.clinic_name}}</td>
                              <td>{{booking.converted_status}}</td>
                              <td><p class="w-100px">{{booking.converted_created_at}}</p></td>
                             
                              <td>
                                 <router-link :to="{ name: 'bookings.details', params: {id: booking.id } }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>
                                 
                                 <button class="btn btn-success me-2 mb-2 btn-sm" type="button" v-if="(booking.status == 2 || booking.status == 5) && booking.booking_datetime < now" @click="completeBooking(booking.id)">Complete</button>
                                 
                                 <button v-b-modal.reschedule-modal class="btn btn-warning me-2 mb-2 btn-sm" type="button" v-if="booking.status == 2 || booking.status == 5" @click="reschedule(booking)">Reschedule</button>

                                 <button class="btn btn-danger me-2 mb-2 btn-sm" type="button" v-if="booking.status == 2 || booking.status == 5" @click="cancelBooking(booking.id)" >Cancel</button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="8" class="text-center">No bookings found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(bookings.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchBookings(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

                  <!---- modal starts ---->
                  <b-modal ref="reschedule-modal" id="reschedule-modal" title="Reschedule" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="updateBooking()">                        
                        <div class="row">                           

                           <b-form-group>
                              <label>Date and Time <span class="text-danger">*</span></label>
                             <b-form-input type="datetime-local" v-model="booking.booking_time" v-bind:class="{ 'is-invalid': Boolean(errors.booking_time) }" :min="min_date"></b-form-input>

                             <div v-for="(val, index) in errors.booking_time" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> 
                           </b-form-group>


                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                              <b-button class="" variant="light" @click="hideModal('reschedule-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
